import { render } from "./LayoutNewDesign.vue?vue&type=template&id=37de4662&scoped=true"
import script from "./LayoutNewDesign.vue?vue&type=script&lang=js"
export * from "./LayoutNewDesign.vue?vue&type=script&lang=js"

import "./LayoutNewDesign.vue?vue&type=style&index=0&id=37de4662&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37de4662"]])

export default __exports__